import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistrationSectoralMeeting } from 'app/models/convention-registration-sectoral-meeting.model';
import { EventConvention } from 'app/models/event-convention.model';
import { SectoralMeetingExtension } from 'app/models/extensions/sectoral-meeting-extension.model';
import { LOVSectoralMeetingStatus } from 'app/models/lov-sectoral-meeting-status.model';
import { MRMValidators } from '@mrm/core';

export class SectoralMeeting extends SectoralMeetingExtension {
  sectoralMeetingDBID: number = 0;
  conventionDBID: number = 0;
  englishName: string = null;
  frenchName: string = null;
  englishDescription: string = null;
  frenchDescription: string = null;
  startDate: Date = new Date();
  startTime: string = null;
  room: string = null;
  roomCapacity?: number = null;
  location: string = null;
  sectoralMeetingStatusDBID: number = 0;
  facilitator: string = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  convention: EventConvention = null;
  sectoralMeetingStatus: LOVSectoralMeetingStatus = null;
  conventionRegistrationSectoralMeetings: ConventionRegistrationSectoralMeeting[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      sectoralMeetingDBID: new FormControl({ value: 0, disabled: disableAll }),
      conventionDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      englishName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(4000)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(4000)]),
      startDate: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      startTime: new FormControl({ value: null, disabled: disableAll }, [Validators.required]),
      room: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(50)]),
      roomCapacity: new FormControl({ value: null, disabled: disableAll }),
      location: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      sectoralMeetingStatusDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      facilitator: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionRegistrationSectoralMeetings: new FormArray([])
    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'convention':
            form.addControl('convention', EventConvention.getForm(disableAll)); break;
          case 'sectoralmeetingstatus':
            form.addControl('sectoralMeetingStatus', LOVSectoralMeetingStatus.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of SectoralMeeting. Please use one of the following navigational property: 'convention' | 'sectoralMeetingStatus'`);
        }
      }
    }

    return form;
  }
}